import DashboardLayout from '@/layouts/DashboardLayout.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import auth from '@/middleware/auth';
import type { Middleware } from '@/types/router';
import { MuslimHubRouteName } from '@/types/router/name/muslim-hub';
import { MuslimHubRoutePath } from '@/types/router/path/muslim-hub';

export default [
    {
        path: MuslimHubRoutePath.Registration,
        name: MuslimHubRouteName.Registration,
        component: () => import('@/pages/muslim-hub/registration/index.vue'),
        meta: {
            group: 'muslim-hub',
            sub: 'registration',
            title: 'Pendaftaran Kreator Muslim Hub',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: MuslimHubRoutePath.RegistrationVerification,
        name: MuslimHubRouteName.RegistrationVerification,
        component: () => import('@/pages/muslim-hub/registration/verification/index.vue'),
        meta: {
            group: 'muslim-hub',
            sub: 'registration',
            title: 'Review Data Kreator Muslim Hub',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: MuslimHubRoutePath.ActivityApproval,
        name: MuslimHubRouteName.ActivityApproval,
        component: () => import('@/pages/muslim-hub/activity-approval/index.vue'),
        meta: {
            group: 'muslim-hub',
            sub: 'activity-approval',
            title: 'Approval Kegiatan Kreator Muslim Hub',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: MuslimHubRoutePath.ApprovalVerification,
        name: MuslimHubRouteName.ApprovalVerification,
        component: () => import('@/pages/muslim-hub/activity-approval/verification/index.vue'),
        meta: {
            group: 'muslim-hub',
            sub: 'activity-approval',
            title: 'Review Data Kegiatan Kreator Muslim Hub',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: MuslimHubRoutePath.AreaApproval,
        name: MuslimHubRouteName.AreaApproval,
        component: () => import('@/pages/muslim-hub/area-approval/index.vue'),
        meta: {
            group: 'muslim-hub',
            sub: 'area-approval',
            title: 'Approval Tempat Kreator Muslim Hub',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: MuslimHubRoutePath.AreaApprovalVerification,
        name: MuslimHubRouteName.AreaApprovalVerification,
        component: () => import('@/pages/muslim-hub/area-approval/verification/index.vue'),
        meta: {
            group: 'muslim-hub',
            sub: 'area-approval',
            title: 'Review Data Tempat Kreator Muslim Hub',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: MuslimHubRoutePath.CreatorManagement,
        name: MuslimHubRouteName.CreatorManagement,
        component: () => import('@/pages/muslim-hub/list/index.vue'),
        meta: {
            group: 'muslim-hub',
            sub: 'creator-management',
            title: 'Manajemen Kreator Muslim Hub',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: MuslimHubRoutePath.CreatorDetail,
        name: MuslimHubRouteName.CreatorDetail,
        component: () => import('@/pages/muslim-hub/list/detail/index.vue'),
        meta: {
            group: 'muslim-hub',
            sub: 'creator-management',
            title: 'Detail Kegiatan Kreator Muslim Hub',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: MuslimHubRoutePath.CreatorDetailProfile,
        name: MuslimHubRouteName.CreatorDetailProfile,
        component: () => import('@/pages/muslim-hub/list/detail/profile/index.vue'),
        meta: {
            group: 'muslim-hub',
            sub: 'creator-management',
            title: 'Profile Kreator Muslim Hub',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: MuslimHubRoutePath.CreatorDetailAgenda,
        name: MuslimHubRouteName.CreatorDetailAgenda,
        component: () => import('@/pages/muslim-hub/list/detail/agenda/index.vue'),
        meta: {
            group: 'muslim-hub',
            sub: 'creator-management',
            title: 'Detail Agenda Kegiatan Kreator Muslim Hub',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: MuslimHubRoutePath.CreatorDetailRating,
        name: MuslimHubRouteName.CreatorDetailRating,
        component: () => import('@/pages/muslim-hub/list/detail/rating/index.vue'),
        meta: {
            group: 'muslim-hub',
            sub: 'creator-management',
            title: 'Detail Penilaian Kegiatan Kreator Muslim Hub',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: MuslimHubRoutePath.CreatorDetailPlace,
        name: MuslimHubRouteName.CreatorDetailPlace,
        component: () => import('@/pages/muslim-hub/list/detail/place/index.vue'),
        meta: {
            group: 'muslim-hub',
            sub: 'creator-management',
            title: 'Detail Tempat Kegiatan Kreator Muslim Hub',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    }
];
